export const CREATE_NOTICE_STEPS = {
  SHOW_AREA: "show_area",
  FILL_FORM: "fill_form",
  SHOW_USERS: "show_users",
  SHOW_SELECTED_USERS: "show_selected_users",
};

export const READ_STATUS = 1;
